// @ts-nocheck
import React from 'react';

const OsvitaPage = () => {
  return (
    <section className="pt-2 pb-10">
      <div className="container md:px-[65px]">
        <div className="flex flex-col-reverse text-white md:flex-row">
          <div className="relative md:w-3/5 bg-[#A81414] md:h-[500px] px-6 py-2 md:p-8 md:rounded-tl-xl rounded-bl-xl max-md:rounded-br-xl">
            <h2 className="py-3 text-xl font-bold text-justify uppercase md:text-4xl hyphens-manual">Центр професійної освіти Боско</h2>
            <div className="pt-3 pb-3 max-md:leading-5 md:pl-8 hyphens-auto">
              Приватний Заклад “Молодіжний навчальний центр імені святого Івана Боско” (далі - Центр) є приватним професійно-технічним навчальним закладом II - рівня атестації і забезпечує реалізацію потреб громадян у професійно-технічній освіті, оволодінні робітничими професіями відповідно до їх інтересів, потреб, стану здоров'я і є єдиним в Україні приватним католицьким закладом. Заклад розпочав свою діяльність з 2003 року.
            </div>
            <div className="pt-3 pb-3 md:pl-8 hyphens-auto max-md:leading-5">
              Центр здійснює первинну професійну підготовку робітників, як правило, з числа випускників загальноосвітніх навчальних закладів на основі базової чи повної загальної середньої освіти.
            </div>
            <div className="pt-3 pb-3 md:pl-8 hyphens-auto max-md:leading-5">
              Формування учнівського контингенту проводиться згідно із «Правилами прийому до ПЗ «Молодіжний навчальний центр імені святого Івана Боско», виходячи з потреб регіону в робітничих кадрах. Підготовка кваліфікованих робітників за професією здійснюється на підставі робочих навчальних планів, які розроблені у відповідності до вимог, погоджені і затверджені в установленому порядку з врахуванням регіонального компоненту.
            </div>
          </div>
          <div className="relative md:w-2/5">
            <div class="hidden md:block absolute md:top-1/2 md:left-0 md:-translate-y-1/2 border-[#A81414]
              w-0 h-0
              border-t-[20px] border-b-[20px] border-l-[10px]
              md:border-t-[250px] md:border-b-[250px] md:border-l-[100px]
              border-t-transparent border-b-transparent border-l-red-600">
            </div>
            <div class="md:hidden block absolute bottom-0 md:left-0 md:-translate-y-1/2 border-[#A81414]
              w-0 h-0
              border-b-[30px] border-l-[calc(50vw-20px)] border-r-[calc(50vw-20px)]
              md:border-t-[200px] md:border-b-[200px] md:border-l-[100px]
              border-l-transparent border-r-transparent border-t-transparent border-t-red-600">
            </div>
            <img
              className="md:h-[500px] object-cover object-center rounded-tr-xl md:rounded-br-xl rounded-tl-xl md:rounded-tl-none"
              src="/images/osvita.png"
              alt=""
            />
          </div>
        </div>
        <div className="flex flex-col items-center md:pl-16 md:flex-row">

          <div className="relative md:w-1/2">
            <div>
              <div className="pt-6 text-md">
                Професії, які є на базі Центру:
              </div>
              <ul className="pl-6 list-disc">
                <li className="texl-md">Автомеханік - автоелектрик,</li>
                <li className="texl-md">Веб дизайнер,</li>
                <li className="texl-md">ІТ-розробник,</li>
                <li className="texl-md">Кухар-офіціант,</li>
                <li className="texl-md">Столяр.</li>
              </ul>
            </div>
            <div class="hidden md:block absolute top-1/2 right-0 -translate-y-1/2 border-[#A81414] 
              w-0 h-0
              border-t-[42px] border-b-[40px] border-r-[20px]
              border-t-transparent border-b-transparent border-l-red-600">
            </div>
          </div>
          <div className="max-md:mt-4 relative max-md:ml-[16px] md:w-2/3 bg-[#A81414] md:h-[80px] flex justify-center items-center px-8 rounded-tr-xl rounded-br-xl">
            <div class="md:hidden absolute top-1/2 -left-[22px] -translate-y-1/2 border-[#A81414] 
              w-0 h-0
              border-t-[54px] border-b-[54px] border-r-[22px]
              border-t-transparent border-b-transparent border-l-red-600">
            </div>
            <h3 className="text-[14px] items-center flex  justify text-white uppercase text- nt-bold hyphens-auto max-md:leading-4 max-md:py-[14px]">
              Велика увага приділяється соціальному захисту дітей, позбавлених батьківського піклування, дітей-сиріт, напівсиріт та дітей із малозабезпечених сімей.
            </h3>
          </div>
        </div>

        <div className="py-6 md:px-16">
          <ul className="flex flex-col gap-5 text-justify hyphens-auto ">
            <li>
              Організація навчально-виховної діяльності Центру здійснюється за перспективним планом роботи на навчальний рік та іншими нормативно-правовими документами. Тому МНЦ покликаний надати не тільки освіту та професійні здібності цим дітям, орієнтуючи на майбутнє залучення у світ праці, але й зайнятись їх вихованням і формуванням зрілої особистості. Дбати про їх духовний розвиток, насамперед вести їх у воцерковлене життя.
            </li>
          </ul>
        </div>

        <div className="flex flex-col justify-between py-4 md:px-16 md:flex-row">
          <div className="">
            <div className="text-[#A81414] font-bold pt-2 text-lg md:text-xl">
              ЦЕНТР ПРОФЕСІЙНОЇ ОСВІТИ БОСКО
            </div>
            <div className="flex my-2 max-md:ml-4">
              <div className="hidden md:flex border-[2px] border-[#A81414] mr-6">
              </div>
              <div className="flex md:hidden border-[2px] border-[#A81414] mr-6">
              </div>
              <div>
                <div className="py-3">
                  Директор: отець Андрій Боднар, СДБ
                </div>
                <div className="">
                  Вул. Дорога Кривчицька, 19
                </div>
                <div className="">
                  Львів
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default OsvitaPage;
